import './login.css';

window.addEventListener('DOMContentLoaded', () => {
    const $form = document.querySelector('#loginForm'),
        $errorsDiv = document.querySelector('div#errors');

    if (!$form.dataset.errors) return;

    const errors = JSON.parse($form.dataset.errors);

    errors.forEach((err) => showError(err));

    $form.addEventListener('submit', (e) => {
        e.preventDefault();

        const formData = new FormData(e.target),
            email = formData.get('email'),
            password = formData.get('password');

        if (!email || !password) {
            $errorsDiv.innerHTML = '';
            showError('Please fill the fields.');
            return false;
        }

        e.target.submit();
    });

    function showError(error) {
        $errorsDiv.insertAdjacentHTML(
            'beforeend',
            `<div class="bg-red-500 py-2 px-4 mt-2 text-white text-sm rounded">${error}</div>`
        );
    }
});

